import React, { useState, useEffect, useRef, memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import octopusAnimation from "../assets/Octopus.json";
import image1 from "../assets/1.jpg";
import image2 from "../assets/2.jpg";
import image3 from "../assets/3.jpg";
import imageX from "../assets/X.png";
import imageY from "../assets/Y.png";
import imageZ from "../assets/Z.png";
import footerImage from "../assets/Footer.png";
import abhigyanImg from "../assets/Abhigyan.png";
import shrishtiImg from "../assets/Shrishti.png";
import bidyutImg from "../assets/Bidyut.png";
import venkatImg from "../assets/Venkat.png";
import neelImg from "../assets/Neel.png";
import ektaImg from "../assets/Ekta.png";
import jamesImg from "../assets/James.png";
import isabellaImg from "../assets/Isabella.png";
import williamImg from "../assets/William.png";
import Age5 from "../assets/Age5.png";
import Age6 from "../assets/Age6.png";
import Age7 from "../assets/Age7.png";
import Age8 from "../assets/Age8.png";
import Age9 from "../assets/Age9.png";
import Age10 from "../assets/Age10.png";
import Age11 from "../assets/Age11.png";
import Age12 from "../assets/Age12.png";
import Age13 from "../assets/Age13.png";
import Age14 from "../assets/Age14.png";
import Age15 from "../assets/Age15.png";
import Age16 from "../assets/Age16.png";
import harvardImg from "../assets/harvard.png";
import oxfordImg from "../assets/oxford.png";
import scholarshipImg from "../assets/scholarship.gif";
import aiSchoolImg from "../assets/aischool.jpg";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, FacebookIcon, XIcon, WhatsappIcon } from "react-share";

const translations = {
  en: {
    header: {
      logo: "drOcto",
      login: "Login",
    },
    main: {
      title: "Is Your Child Falling Behind in World’s Race to Success?",
      h1: "Is Your Child Falling Behind in the Race to Success?",
      subtitle1: "In 2025, 93% of Indian kids lack the skills to compete—don’t let yours be one of them.",
      subtitle2: "Protect your child from failing in life—build real world skills from an young age by interacting with our AI for just 15-20 minutes every day.",
      trustBadge: "Designed in IIT Madras",
    },
    trainedOn: {
      title: "Developed Using Concepts From Harvard and Oxford",
    },
    whyChoose: {
      title: "Why Choose drOcto?",
      feature1: {
        title: "🧠 Outsmart the Competition",
        text: "Develop your Child's brainpower to beat lakhs of students in exams & jobs in future.",
      },
      feature2: {
        title: "💯 Street-Smart Survival",
        text: "Teach your child to thrive in India’s tough Real World, not just classrooms.",
      },
      feature3: {
        title: "💪 Job-Ready by 18",
        text: "Secure your child’s future in a Country where 70% of graduates are unemployed.",
      },
      warning: "Without these skills, your child risks a lifetime of struggle in India.",
    },
    ageFocus: {
      title: "Targeted Growth for Every Age—Don’t Let Your Child Miss Out!",
      text: "Smart parents are already preparing their kids for the future with drOcto’s age-specific learning. Each stage is crafted to build critical skills that schools don’t teach!",
      button: "Secure My Child’s Future",
    },
    results: {
      title: "Real Results with drOcto",
      result1: "53% More Enthusiasm and Creativity",
      result2: "89% More Likely to Crack Top Jobs",
    },
    testimonials: {
      title: "What Parents Are Saying About drOcto",
      quote1: "My son went from average to topping his class—drOcto saved his future!",
      quote2: "I was terrified he’d end up jobless like my neighbor’s son. Now he’s confident and sharp.",
      quote3: "Every parent in our society is jealous of my daughter’s progress!",
    },
    whyAI: {
      title: "What is drOcto? An AI-Powered Learning Platform",
      text: "drOcto is an AI-based interactive learning platform. Our AI will talk with your child every day. Interacting with our AI boosts your child’s critical thinking and adaptability—skills no textbook can teach. drOcto AI engages kids in real-time, making learning fun, personalized, and future-ready for India’s competitive edge.",
    },
    dailyRank: {
      title: "Daily Rank Updates",
      text: "Know exactly where your child stands compared to other kids! Get daily updates on their rank. Points are added after every chat session.",
      button: "💡 Create my Drocto ID",
    },
    parentsSection: {
      title: "Secured Parents Section: Monitor Your Child’s Progress",
      text: "We update you about your child’s progress and highlight what he or she lacks, so you can work on solving it before it’s too late!",
      feature1: {
        title: "🔒 Private Updates",
        text: "Exclusive access to progress reports",
      },
      feature2: {
        title: "🚀 Skill Gaps",
        text: "Identify areas needing improvement",
      },
      feature3: {
        title: "👣 Actionable Steps",
        text: "Get tips to boost their growth",
      },
    },
    footer: {
      text: "Don’t Risk Your Child’s Future in India’s Do-or-Die World—Act Today.",
      button: "Free Scholarship Test",
      faq: [
        {
          question: "How does drOcto help my child?",
          answer: "It builds critical thinking, problem-solving, and real-world skills through fun, interactive AI-driven activities.",
        },
        {
          question: "Is it suitable for all ages?",
          answer: "Yes, drOcto adapts to kids aged 5-16, tailoring challenges to their skill level.",
        },
        {
          question: "How soon will I see results?",
          answer: "Most parents notice sharper thinking and better grades within 30 days of daily use.",
        },
      ],
    },
    popup: {
      button: "Claim Offer",
    },
    socialShare: {
      title: "Spread the Word About drOcto",
      facebook: "Help your child excel with drOcto! It’s an AI-based platform that builds critical skills for India’s competitive world. Join now!",
      twitter: "Prepare your child for success with drOcto! Fun AI learning for kids to build real-world skills. Check it out!",
      whatsapp: "Give your child a head start with drOcto! An AI platform to build critical thinking and future-ready skills. Join today!",
    },
  },
};

const OctopusAnimationSection = memo(() => {
  const lottieRef = useRef();

  useEffect(() => {
    console.log("OctopusAnimationSection rendered");
  });

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.stop();
      lottieRef.current.setSpeed(1);
      lottieRef.current.play();
    }
  }, []);

  return (
    <section className="octopus-animation-section">
      <div className="lottie-wrapper">
        <Lottie
          lottieRef={lottieRef}
          animationData={octopusAnimation}
          loop={true}
          style={{ width: 200, height: 200 }}
        />
      </div>
    </section>
  );
}, () => true);

const ThinkyPlayLanding = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [selectedRank, setSelectedRank] = useState("Class");

  useEffect(() => {
    const popupInterval = setInterval(() => {
      setShowPopup(true);
    }, 27000);

    return () => clearInterval(popupInterval);
  }, []);

  const handleCTAClick = useCallback(() => navigate("/account"), [navigate]);
  const handleSchoolLoginClick = useCallback(() => navigate("/schools"), [navigate]);

  const toggleFaq = useCallback((index) => {
    setExpandedFaq((prev) => (prev === index ? null : index));
  }, []);

  const rankingsData = {
    Class: [
      { id: 10, name: "James", points: 2200, profilePic: jamesImg },
      { id: 11, name: "Sophie", points: 2000, profilePic: isabellaImg },
      { id: 12, name: "Liam", points: 1800, profilePic: williamImg },
    ],
    State: [
      { id: 1, name: "Abhigyan", points: 3200, profilePic: abhigyanImg },
      { id: 2, name: "Shrishti", points: 3000, profilePic: shrishtiImg },
      { id: 3, name: "Bidyut", points: 2800, profilePic: bidyutImg },
    ],
    Country: [
      { id: 4, name: "Venkat", points: 2600, profilePic: venkatImg },
      { id: 5, name: "Neel", points: 2450, profilePic: neelImg },
      { id: 6, name: "Ekta", points: 2300, profilePic: ektaImg },
    ],
    World: [
      { id: 7, name: "James", points: 2100, profilePic: jamesImg },
      { id: 8, name: "Isabella", points: 1900, ListItemprofilePic: isabellaImg },
      { id: 9, name: "William", points: 1700, profilePic: williamImg },
    ],
  };

  const rankIcons = {
    Class: "🏫",
    State: "🌆",
    Country: "🇮🇳",
    World: "🌍",
  };

  const TrustBadges = () => (
    <div className="trust-badges">
      <span>{translations.en.main.trustBadge}</span>
    </div>
  );

  const TrainedOnSection = () => (
    <section className="card">
      <h2>{translations.en.trainedOn.title}</h2>
      <div className="feature-grid">
        {[
          { src: harvardImg, alt: "Harvard University" },
          { src: oxfordImg, alt: "Oxford University" },
        ].map((item, index) => (
          <div key={index} className="trained-on-item">
            <img src={item.src} alt={item.alt} className="trained-on-image" />
          </div>
        ))}
      </div>
    </section>
  );

  const Testimonials = () => (
    <section className="card">
      <h2>{translations.en.testimonials.title}</h2>
      <div className="feature-grid">
        {[
          { name: "Priya S., Bangalore", text: translations.en.testimonials.quote1 },
          { name: "Ramesh K., Delhi", text: translations.en.testimonials.quote2 },
          { name: "Anita M., Mumbai", text: translations.en.testimonials.quote3 },
        ].map((item, index) => (
          <div key={index}>
            <p className="quote">{item.text}</p>
            <p className="author">— {item.name}</p>
          </div>
        ))}
      </div>
    </section>
  );

  const Results = () => (
    <section className="card">
      <h2>{translations.en.results.title}</h2>
      <div className="results-grid">
        <div>
          <p>53%</p>
          <p>{translations.en.results.result1}</p>
        </div>
        <div>
          <p>89%</p>
          <p>{translations.en.results.result2}</p>
        </div>
      </div>
    </section>
  );

  const AgeFocusTopics = () => (
    <section className="card age-focus-section">
      <h2>{translations.en.ageFocus.title}</h2>
      <p>{translations.en.ageFocus.text}</p>
      <button className="button" onClick={handleCTAClick}>
        {translations.en.ageFocus.button}
      </button>
    </section>
  );

  const WhyAI = () => {
    const lottieRef = useRef();

    useEffect(() => {
      if (lottieRef.current) {
        lottieRef.current.stop();
        lottieRef.current.setSpeed(1);
        lottieRef.current.play();
      }
    }, []);

    return (
      <section className="card why-ai">
        <h2>{translations.en.whyAI.title}</h2>
        <p>{translations.en.whyAI.text}</p>
      </section>
    );
  };

  const DailyRankUpdates = () => {
    const rankSectionRef = useRef(null);

    const handleRankChange = useCallback((category) => {
      const scrollPosition = rankSectionRef.current ? rankSectionRef.current.scrollTop : 0;
      setSelectedRank(category);
      setTimeout(() => {
        if (rankSectionRef.current) {
          rankSectionRef.current.scrollTop = scrollPosition;
        }
      }, 0);
    }, []);

    return (
      <section className="card" ref={rankSectionRef}>
        <h2>{translations.en.dailyRank.title}</h2>
        <p>{translations.en.dailyRank.text}</p>
        <div className="rank-tabs">
          {["Class", "State", "Country", "World"].map((category) => (
            <button
              key={category}
              className={`rank-tab ${selectedRank === category ? "active" : ""}`}
              onClick={() => handleRankChange(category)}
            >
              <span className={`rank-icon ${selectedRank === category ? "active-icon" : ""}`}>
                {rankIcons[category]}
              </span>
              {category}
            </button>
          ))}
        </div>
        <div className="ranking-container">
          <div className="rank-list">
            {rankingsData[selectedRank].map((kid, index) => (
              <div key={kid.id} className="rank-item">
                <img src={kid.profilePic} alt={kid.name} className="rank-image" />
                <div className="rank-details">
                  <p className="rank-position">#{index + 1}</p>
                  <p className="rank-name">{kid.name}</p>
                  <p className="rank-points">{kid.points} pts</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button className="button" onClick={handleCTAClick}>{translations.en.dailyRank.button}</button>
      </section>
    );
  };

  const SecuredParentsSection = () => (
    <section className="card">
      <h2>{translations.en.parentsSection.title}</h2>
      <p>{translations.en.parentsSection.text}</p>
      <div className="feature-grid">
        <div>
          <h3>{translations.en.parentsSection.feature1.title}</h3>
          <p>{translations.en.parentsSection.feature1.text}</p>
        </div>
        <div>
          <h3>{translations.en.parentsSection.feature2.title}</h3>
          <p>{translations.en.parentsSection.feature2.text}</p>
        </div>
        <div>
          <h3>{translations.en.parentsSection.feature3.title}</h3>
          <p>{translations.en.parentsSection.feature3.text}</p>
        </div>
      </div>
    </section>
  );

  const ActivityImagesSection = () => (
    <section className="card">
      <h2>drOcto way of learning!</h2>
      <div className="feature-grid">
        {[image1, image2, image3].map((image, index) => (
          <div key={index} className="activity-image-item">
            <img src={image} alt={`Activity ${index + 1}`} className="card-image" />
          </div>
        ))}
      </div>
    </section>
  );

  const SocialShareSection = () => (
    <section className="card">
      <h2>{translations.en.socialShare.title}</h2>
      <div className="social-share-buttons">
        <FacebookShareButton
          url="https://www.drocto.in/"
          quote={translations.en.socialShare.facebook}
        >
          <FacebookIcon size={40} round />
        </FacebookShareButton>
        <TwitterShareButton
          url="https://www.drocto.in/"
          title={translations.en.socialShare.twitter}
        >
          <XIcon size={40} round />
        </TwitterShareButton>
        <WhatsappShareButton
          url="https://www.drocto.in/"
          title={translations.en.socialShare.whatsapp}
        >
          <WhatsappIcon size={40} round />
        </WhatsappShareButton>
      </div>
    </section>
  );

  const ExitPopup = () => (
    showPopup && (
      <div className="exit-popup">
        <div className="popup-content">
          <button className="close-btn" onClick={() => setShowPopup(false)}>
            ✕
          </button>
          <h2>{translations.en.popup.text1}</h2>
          <img 
            src={scholarshipImg} 
            alt="Scholarship Offer" 
            className="popup-image" 
            style={{ maxWidth: "100%", margin: "1rem auto", display: "block" }}
          />
          <p>{translations.en.popup.text1}</p>
          <button className="button" onClick={handleCTAClick}>{translations.en.popup.button}</button>
        </div>
      </div>
    )
  );

  return (
    <div className="page-wrapper">
      <style>{`
        :root {
          --primary: #1E90FF;
          --dark: #1a1a1a;
          --accent: #ff1493;
          --light: #ffffff;
          --neutral: #4a5568;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', sans-serif;
          background: var(--light);
          color: var(--dark);
          line-height: 1.6;
          -webkit-font-smoothing: antialiased;
          overflow-x: hidden;
        }

        .page-wrapper {
          width: 100%;
          min-height: 100vh;
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 20;
          background: var(--light);
          padding: 1rem;
          border-bottom: 1px solid rgba(30, 144, 255, 0.2);
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1280px;
          margin: 0 auto;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .logo-container {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .logo-container span {
          font-size: clamp(1.25rem, 5vw, 1.5rem);
          font-weight: 800;
          letter-spacing: -0.02em;
          color: var(--dark);
          text-align: center;
        }

        .scrollable-content {
          flex: 1;
          overflow-y: auto;
          padding-top: 90px;
        }

        .main-content {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 2rem;
          max-width: 1280px;
          margin: 0 auto;
        }

        .card {
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(30, 144, 255, 0.2);
          border-radius: 1rem;
          padding: 1.5rem;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .scrollable-card {
          padding: 0.375rem;
        }

        .why-ai {
          transition: none;
        }

        .octopus-animation-section {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1.5rem;
        }

        .lottie-wrapper {
          display: flex;
          justify-content: center;
          position: relative;
        }

        .lottie-wrapper svg {
          animation: none !important;
        }

        h1 {
          font-size: clamp(2rem, 6vw, 2.75rem);
          font-weight: 800;
          margin-bottom: 1.5rem;
          line-height: 1.2;
          color: var(--dark);
          text-align: center;
        }

        h2 {
          font-size: clamp(1.25rem, 5vw, 1.75rem);
          font-weight: 700;
          margin-bottom: 1rem;
          text-align: center;
          color: var(--dark);
        }

        h3 {
          font-size: clamp(1rem, 4vw, 1.25rem);
          font-weight: 600;
          margin-bottom: 0.75rem;
          color: var(--dark);
          text-align: center;
        }

        p {
          color: var(--neutral);
          font-size: clamp(0.875rem, 4vw, 1rem);
          text-align: center;
        }

        .button {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          padding: 0.75rem 2rem;
          border-radius: 2rem;
          border: 2px solid var(--primary);
          background: transparent;
          color: var(--primary);
          font-weight: 600;
          font-size: clamp(0.875rem, 4vw, 1rem);
          text-decoration: none;
          cursor: pointer;
          width: 100%;
          max-width: 300px;
          margin: 1rem auto 0;
          transition: all 0.3s ease;
        }

        .button:hover {
          background: var(--primary);
          color: var(--light);
        }

        .login-button {
          max-width: 100px;
          margin: 0 auto;
        }

        .school-login-button {
          max-width: 200px;
          background: var(--accent);
          border-color: var(--accent);
          color: var(--light);
          margin: 1rem auto 0;
        }

        .school-login-button:hover {
          background: var(--primary);
          border-color: var(--primary);
        }

        .ai-school-button {
          max-width: 320px;
          margin: 1rem auto;
          cursor: pointer;
          border-radius: 0.75rem;
          border: 2px solid var(--primary);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .ai-school-button:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 15px rgba(30, 144, 255, 0.3);
        }

        .trust-badges {
          display: flex;
          justify-content: center;
          gap: 0.75rem;
          margin-top: 1.5rem;
        }

        .trust-badges span {
          padding: 0.5rem 1rem;
          background: var(--primary);
          color: var(--light);
          border-radius: 2rem;
          font-size: clamp(0.75rem, 3vw, 0.875rem);
          font-weight: 600;
          text-align: center;
        }

        .feature-grid {
          display: grid;
          gap: 1.5rem;
          padding: 1rem 0;
          width: 100%;
        }

        .feature-grid > div {
          text-align: center;
        }

        .feature-grid h3 {
          color: var(--primary);
          font-weight: 700;
          font-size: clamp(1rem, 4vw, 1.25rem);
        }

        .feature-grid p {
          color: var(--neutral);
          font-size: clamp(0.875rem, 3.5vw, 1rem);
        }

        .trained-on-item,
        .activity-image-item {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .trained-on-image {
          max-width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 0.75rem;
          border: none;
          margin: 0 auto;
        }

        .card-image {
          max-width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 0.75rem;
          border: 1px solid var(--primary);
          margin: 0 auto;
        }

        .quote {
          font-style: italic;
          color: var(--dark);
          text-align: center;
        }

        .author {
          color: var(--neutral);
          font-size: clamp(0.75rem, 3vw, 0.875rem);
          margin-top: 0.5rem;
          text-align: center;
        }

        .results-grid {
          display: grid;
          gap: 1.5rem;
          margin-bottom: 1.5rem;
          text-align: center;
          width: 100%;
        }

        .results-grid p:first-child {
          font-size: clamp(2rem, 8vw, 2.5rem);
          font-weight: 800;
          color: var(--primary);
        }

        .results-grid p:last-child {
          font-size: clamp(0.875rem, 3.5vw, 1rem);
          color: var(--neutral);
        }

        .age-focus-section {
          background: rgba(240, 248, 255, 0.9);
          border: 2px solid var(--primary);
          box-shadow: 0 0 10px rgba(30, 144, 255, 0.2);
        }

        .urgent-cta {
          color: var(--dark);
          font-weight: 600;
          margin-top: 1rem;
          text-align: center;
        }

        .cards-container {
          width: 100%;
          overflow-x: auto;
          padding: 0.5rem 0;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .cards-container::-webkit-scrollbar {
          display: none;
        }

        .cards-wrapper {
          display: flex;
          gap: 1rem;
          padding: 0;
          min-width: 100%;
        }

        .card-item {
          width: clamp(250px, 80vw, 280px);
          height: clamp(180px, 60vw, 200px);
          flex-shrink: 0;
        }

        .age-card-item {
          width: clamp(250px, 80vw, 280px);
          height: clamp(160px, 50vw, 180px);
          flex-shrink: 0;
        }

        .footer {
          padding: 1.5rem;
          text-align: center;
          background: var(--light);
          border-top: 1px solid rgba(30, 144, 255, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .footer-image {
          width: 100%;
          max-width: 364px;
          margin: 1.5rem auto 0;
          display: block;
        }

        .faq-section {
          margin-top: 1.5rem;
          text-align: center;
          max-width: 100%;
        }

        .faq-item {
          margin-bottom: 0.75rem;
          border-bottom: 1px solid rgba(30, 144, 255, 0.2);
        }

        .faq-question {
          color: var(--primary);
          font-weight: 600;
          margin-bottom: 0.5rem;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: clamp(0.875rem, 4vw, 1rem);
        }

        .faq-question::after {
          content: '➤';
          transform: rotate(${expandedFaq !== null ? '90deg' : '0deg'});
          transition: transform 0.3s ease;
        }

        .faq-answer {
          max-height: ${expandedFaq !== null ? '200px' : '0'};
          overflow: hidden;
          transition: max-height 0.3s ease;
          color: var(--neutral);
          text-align: center;
        }

        .exit-popup {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.75);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          padding: 1rem;
        }

        .popup-content {
          position: relative;
          width: 100%;
          max-width: 400px;
          background: var(--light);
          border: 1px solid rgba(30, 144, 255, 0.2);
          border-radius: 0.75rem;
          padding: 1.5rem;
          text-align: center;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }

        .close-btn {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
          background: none;
          border: none;
          color: var(--neutral);
          font-size: 1.25rem;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .close-btn:hover {
          color: var(--primary);
        }

        .popup-image {
          max-width: 100%;
          margin: 1rem auto;
          display: block;
          border-radius: 0.75rem;
        }

        .rank-tabs {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 0.75rem;
          margin: 1rem 0;
        }

        .rank-tab {
          display: flex;
          align-items: center;
          padding: 0.5rem 1rem;
          background: none;
          border: none;
          color: var(--neutral);
          font-weight: 600;
          font-size: clamp(0.875rem, 4vw, 1rem);
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .rank-tab:hover {
          color: var(--primary);
        }

        .rank-tab.active {
          background: none;
          color: var(--primary);
          border: none;
        }

        .rank-icon {
          margin-right: 0.5rem;
          font-size: clamp(1rem, 4vw, 1.25rem);
          transition: all 0.3s ease;
        }

        .rank-icon.active-icon {
          color: var(--primary);
          transform: scale(1.2);
        }

        .ranking-container {
          display: flex;
          justify-content: center;
        }

        .rank-list {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          width: 100%;
          max-width: 350px;
        }

        .rank-item {
          display: flex;
          align-items: center;
          background: rgba(240, 240, 240, 0.8);
          border-radius: 0.5rem;
          padding: 0.5rem;
          width: 100%;
          gap: 0.5rem;
        }

        .rank-image {
          width: clamp(32px, 10vw, 36px);
          height: clamp(32px, 10vw, 36px);
          border-radius: 50%;
          border: 2px solid var(--primary);
          object-fit: cover;
          flex-shrink: 0;
        }

        .rank-details {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-grow: 1;
        }

        .rank-position {
          font-size: clamp(0.875rem, 3.5vw, 1rem);
          font-weight: 700;
          color: var(--primary);
          min-width: 40px;
          text-align: left;
        }

        .rank-name {
          font-size: clamp(0.875rem, 3.5vw, 1rem);
          color: var(--dark);
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rank-points {
          font-size: clamp(0.75rem, 3vw, 0.875rem);
          color: var(--neutral);
          min-width: 60px;
          text-align: right;
        }

        .social-share-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 1rem;
        }

        .social-share-buttons button {
          transition: transform 0.3s ease;
        }

        .social-share-buttons button:hover {
          transform: scale(1.1);
        }

        @media (min-width: 640px) {
          .header { padding: 1.25rem 2rem; }
          .main-content { padding: 2rem; gap: 2.5rem; }
          .card { padding: 2rem; }
          .scrollable-card { padding: 0.375rem; }
          h1 { font-size: 2.25rem; }
          h2 { font-size: 1.75rem; }
          .feature-grid { grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); }
          .results-grid { grid-template-columns: repeat(2, 1fr); }
          .scrollable-content { padding-top: 100px; }
          .button { max-width: 350px; }
          .card-item { width: 300px; height: 220px; }
          .age-card-item { width: 300px; height: 190px; }
          .trained-on-image,
          .card-image { max-width: 280px; }
          .rank-item {
            padding: 0.75rem;
            gap: 0.75rem;
          }
          .rank-image {
            width: 40px;
            height: 40px;
          }
          .rank-details {
            gap: 0.75rem;
          }
          .rank-position {
            min-width: 50px;
          }
          .rank-points {
            min-width: 70px;
          }
          .ai-school-button {
            max-width: 250px;
          }
        }

        @media (min-width: 1024px) {
          .header { padding: 1.5rem 3rem; }
          .main-content { padding: 3rem; gap: 3rem; }
          .card { padding: 2.5rem; }
          .scrollable-card { padding: 0.375rem; }
          h1 { font-size: 2.75rem; }
          h2 { font-size: 2rem; }
          .feature-grid { grid-template-columns: repeat(3, 1fr); }
          .card-item { width: 320px; height: 240px; }
          .age-card-item { width: 320px; height: 200px; }
          .logo-container span { font-size: 1.75rem; }
          .scrollable-content { padding-top: 120px; }
          .button { max-width: 400px; }
          .trained-on-image,
          .card-image { max-width: 300px; }
          .ai-school-button {
            max-width: 300px;
          }
        }
      `}</style>

      <head>
        <title>{translations.en.main.h1}</title>
        <meta name="description" content={translations.en.main.subtitle1} />
      </head>

      <header className="header">
        <div className="header-content">
          <div className="logo-container">
            <Lottie animationData={octopusAnimation} loop={true} style={{ width: 60, height: 60 }} />
            <span>{translations.en.header.logo}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <button className="button login-button" onClick={handleCTAClick}>
              <span style={{ color: "#1E90FF" }}>{translations.en.header.login}</span>
            </button>
          </div>
        </div>
      </header>

      <div className="scrollable-content">
        <main className="main-content">
          <h1>{translations.en.main.h1}</h1>

          <section className="card">
            <p>{translations.en.main.subtitle1}</p>
            <p>{translations.en.main.subtitle2}</p>
            <TrustBadges />
          </section>

          <TrainedOnSection />

          <section className="card">
            <h2>{translations.en.whyChoose.title}</h2>
            <div className="feature-grid">
              {[
                translations.en.whyChoose.feature1,
                translations.en.whyChoose.feature2,
                translations.en.whyChoose.feature3,
              ].map((item, index) => (
                <div key={index}>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
            <p>{translations.en.whyChoose.warning}</p>
          </section>

          <AgeFocusTopics />
          
          <section className="scrollable-card">
            <div className="cards-container">
              <div className="cards-wrapper">
                {[Age5, Age6, Age7, Age8, Age9, Age10, Age11, Age12, Age13, Age14, Age15, Age16].map((image, index) => (
                  <div key={index} className="age-card-item">
                    <img src={image} alt={`Age ${index + 5}`} className="card-image" />
                  </div>
                ))}
              </div>
            </div>
          </section>

          <Results />
          <Testimonials />
          <OctopusAnimationSection />
          <WhyAI />
          <DailyRankUpdates />
          <SecuredParentsSection />
          
          <ActivityImagesSection />

          <section className="scrollable-card">
            <div className="cards-container">
              <div className="cards-wrapper">
                {[imageX, imageY, imageZ].map((image, index) => (
                  <div key={index} className="card-item">
                    <img src={image} alt={`New Activity ${index + 1}`} className="card-image" />
                  </div>
                ))}
              </div>
            </div>
          </section>

          <SocialShareSection />
        </main>

        <footer className="footer">
          <p>{translations.en.footer.text}</p>
          <button className="button" onClick={handleCTAClick}>{translations.en.footer.button}</button>
          <button className="button school-login-button" onClick={handleSchoolLoginClick}>Login as School</button>
          <img 
            src={aiSchoolImg} 
            alt="AI School" 
            className="ai-school-button" 
            onClick={handleSchoolLoginClick} 
          />
          <div className="faq-section">
            {translations.en.footer.faq.map((faq, index) => (
              <div key={index} className="faq-item">
                <p className="faq-question" onClick={() => toggleFaq(index)}>{faq.question}</p>
                <div className="faq-answer" style={{ maxHeight: expandedFaq === index ? '200px' : '0' }}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          <img src={footerImage} alt="Footer" className="footer-image" />
        </footer>
      </div>

      <ExitPopup />
    </div>
  );
};

export default ThinkyPlayLanding;